import React from 'react';
import logo from './art/WhiteDove-PNG.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p id = "welcomeText">
          Welcome to White Dove Software.
        </p>
        <p id = "renovatingText">
          We are renovating the site. Please check back soon.
        </p>
        
      </header>
    </div>
  );
}

export default App;
